<template>
    <div :class="$themeStyle($store.state.theme.theme)" class="course-card border-4 cu-point flex-c" @click="toCourseDetails">
        <el-image class="border-4 flex1 image" :src="getResouceCover(details.coverId)" fit="cover" />
        <div class="crouse-details fwb">
            <div class="title fs14">{{details.title}}</div>
            <div class="flex align-center m-t-8">
                <div class="flex align-center flex1">
                    <el-image class="m-r-4" v-if="details.logo" style="width: 20px; height: 20px;border-radius:20px;" :src="getResouceCover(details.logo)" fit="fill" />
                    <el-image class="m-r-4" v-else style="width: 20px; height: 20px;border-radius:20px;" src="../assets/logo.png" fit="fill" />
                    <span class="fs12 just-font" :class="$themeStyle($store.state.theme.theme)">{{details.schoolName || '平台课程'}}</span>
                </div>
                <!-- <div class="flex align-center">
                    <i class="el-icon-view m-r-4"></i>
                    <span class="fs12 just-font" :class="$themeStyle($store.state.theme.theme)">12</span>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { resouceCover } from "@/api/user";
export default {
    props: {
        details: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        getResouceCover(key) {
            return resouceCover(key);
        },
        toCourseDetails() {
            this.$router.push("/student/courseDetails?id=" + this.details.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.course-card {
    border: none !important;
    margin: 10px 0;
    .image {
        ::v-deep .el-image__inner, ::v-deep .el-image__error {
            height: 160px;
        }
    }
    .crouse-details {
        padding: 10px 10px 10px 10px;
        .light {
            font-weight: normal;
            color: $greyFontColor;
        }
        .dark {
            font-weight: normal;
            color: $darkSubFontColor;
        }
    }
}
.course-card:hover {
    transform: scale(1.08);
    transition: all 0.3s ease;
}
</style>
